import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'outline' | 'solid';
}

const Button: React.FC<ButtonProps> = ({ variant = 'solid', className, children, ...props }) => {
  const baseClasses =
    'inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/40 disabled:cursor-not-allowed disabled:opacity-50';
  const variantClasses =
    variant === 'outline'
      ? 'border border-zinc-300 text-zinc-700 hover:bg-zinc-50 dark:border-zinc-700 dark:text-zinc-200 dark:hover:bg-zinc-800'
      : 'bg-zinc-900 text-zinc-50 hover:bg-emerald-700 dark:bg-zinc-50 dark:text-zinc-900 dark:hover:bg-emerald-300 active:translate-y-px';

  return (
    <button className={twMerge(baseClasses, variantClasses, className)} {...props}>
      {children}
    </button>
  );
};

export default Button;
